import { Component, EventEmitter, Input, Output } from '@angular/core';

const COMPONENT_SELECTOR = 'wlm-timeline-slider';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './timeline-slider.component.html',
  styleUrl: './timeline-slider.component.scss',
  standalone: false,
})
export class TimelineSliderComponent {
  @Input() title: string;
  @Input() initialValue: number = 0;
  @Output() initialValueChange = new EventEmitter<number>();

  onValueChange(
    value: string | number,
    slider: HTMLInputElement,
    currentValueElement: HTMLElement
  ) {
    this.initialValue = typeof value === 'string' ? parseInt(value) : value;
    this.initialValueChange.emit(this.initialValue);

    if (slider) {
      slider.style.setProperty('--fill-percent', this.initialValue + '%');
    }
    if (currentValueElement) {
      currentValueElement.style.setProperty('--thumb-position', this.initialValue + '%');
    }
  }
}
